<template>
  <div class="home">
    <v-col md="8" offset-md="2">
      <v-card>
        <v-card-title class="secondary white--text">
          <v-icon color="white">mdi-alert</v-icon> Mot de passe oublié
        </v-card-title>

        <v-card-text class="body-1">
          <p class="pt-4">
            Vous avez oublié votre mot de passe. Veuillez saisir votre
            identifiant ou votre adresse mail, puis cliquer sur "Envoyer".
          </p>
          <p>
            Un mail contenant un lien de réinitialisation sera envoyé à votre
            adresse mail.
          </p>
          <v-text-field
            filled
            label="Identifiant"
            placeholder="Veuillez saisir votre identifiant ou votre adresse mail"
            v-model.trim="login"
          />
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="envoyer"
            :loading="envoi"
            :disabled="envoyerDisabled"
          >
            Envoyer
          </v-btn>
          <v-btn text @click="annuler">
            Annuler
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import toasted from '@/utils/toasted';
export default {
  data() {
    return {
      modal: false,
      envoi: false,
      login: null,
    };
  },
  computed: {
    envoyerDisabled() {
      return !this.login;
    },
  },
  methods: {
    envoyer() {
      this.envoi = true;
      this.$api('/motdepasse/oublie')
        .post({ login: this.login })
        .then(() => {
          toasted.info('auth.demandeReinit');
        })
        .finally(() => (this.envoi = false));
    },
    annuler() {
      this.$router.push({ name: 'home' });
    },
  },
};
</script>
<style scoped>
.home {
  background-image: url('~@/assets/images/amanda-vick-eRAq9asBIy4-unsplash.jpg');
  background-size: cover;
  height: 100%;
}

.large {
  width: 100%;
}
</style>
